/**
 * @generated SignedSource<<ed39a95dcd7f0cbb0c5296a9a64fd811>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
import type { FragmentRefs, Result } from "relay-runtime";
export type useEditorContentStateFragment_query$data = Result<{
  readonly availableContentStates: {
    readonly customContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
    } | null> | null;
    readonly spaceContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useEditorContentStateFragment_query";
}, unknown>;
export type useEditorContentStateFragment_query$key = {
  readonly " $data"?: useEditorContentStateFragment_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorContentStateFragment_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = {
  "kind": "ScalarField",
  "name": "color"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEditorContentStateFragment_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "contentId",
          "variableName": "contentId"
        }
      ],
      "concreteType": "AvailableContentStates",
      "kind": "LinkedField",
      "name": "availableContentStates",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentState",
          "kind": "LinkedField",
          "name": "customContentStates",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/)
          ]
        },
        {
          "concreteType": "ContentState",
          "kind": "LinkedField",
          "name": "spaceContentStates",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "kind": "ScalarField",
              "name": "restrictionLevel"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "b929eaf6ffcfb989eca49bfbc256598c";

export default node;
